export default [{
  path: '/admin/install',
  name: 'Install',
  component: () => import('@/views/install/'),
  meta: {
    title: '安装向导',
    keepAlive: false,
    auth: false,
    headType: -1
  }
}]



// WEBPACK FOOTER //
// ./src/router/public.js